import { useQuery } from '@tanstack/react-query';

import { getAccountFeatures } from '@/api/accountFeatures';
import { useCurrentApp } from '@/stores/userDataStore';

export const useAccountFeatures = () => {
  const { appKey, isLoggedIn, isLoading: isLoadingUser } = useCurrentApp();

  const { data, isLoading, error } = useQuery({
    queryKey: ['account-features', appKey],
    queryFn: () => getAccountFeatures(appKey),
    enabled: !!appKey && isLoggedIn,
    staleTime: 5 * 60 * 1000,
  });

  return { data, isLoading: isLoadingUser || isLoading, error };
};
